<template>
  <main id="invite_body">
    <div class="wrapper">
      <div class="top_title">
        <p>
          <span>EVENT</span>
          <i onclick="history.back();" class="fas fa-times"></i>
        </p>
      </div>
      <div class="">
        <h3>친구 더하면 너도나도 FUS 더해지는</h3>
        <h1>친구더하기 이벤트</h1>
        <p>친구는 10FUS, 나는 5FUS</p>
      </div>
    </div>

    <div class="invite_img"></div>

    <div class="wrapper" id="invite_wrapper">
      <div class="my_code">
        <p>내 추천코드 <span id="code">{{code}}</span></p>
      </div>
      <div class="sub_tit">
        <div class="under_line"></div>
        <p>3가지 방법중 하나로</p>
        <p>친구가 가입하면 바로 지급!</p>
      </div>


      <div class="invite_btn" @click="inviteLink('kakao');">
        <div class="icon">
          <img src="images/basic/event/invite-kakao.svg" alt="">
        </div>
        <p>친구에게 카톡 보내기</p>
        <i class="fas fa-chevron-right"></i>
      </div>
      <div class="invite_btn" @click="inviteLink('share');">
        <div class="icon">
          <img src="images/basic/event/invite-link.svg" alt="">
        </div>
        <p>초대링크로 SNS등에 공유</p>
        <i class="fas fa-chevron-right"></i>
      </div>
      <div class="invite_btn" @click="inviteCode();">
        <div class="icon">
          <img src="images/basic/event/invite-code.svg" alt="">
        </div>
        <p>내 추천코드 복사</p>
        <i class="fas fa-chevron-right"></i>
      </div>

      <div class="notice">
        <p>유의사항</p>
        <span>- 이벤트에 참여완료하면 FUS는 바로 양쪽에 지급됩니다.</span>
        <span>- 설치나 가입 후에는 친구코드를 입력하면 참여가 완료됩니다.</span>
        <span>- 제공되는 FUS코인은 쇼핑이나 기타 다른 컨텐츠에 사용 가능합니다.</span>
        <span>- 본 이벤트는 사정에 따라 변경 혹은 취소될 수 있습니다.</span>
        <span>- 부정한 방법으로 참여시 지급된 FUS가 회수될 수 있습니다.</span>
      </div>
    </div>
  </main>  
</template>

<script>
export default {
  computed: {
    code() {
      return this.$store.state.userInfo.recommendCode;
    },
  },
  created() {
  },
  methods: {
    copy(){
      var code = document.getElementById('code');
      var range = document.createRange();
      range.selectNode(code.childNodes[0]); //텍스트 정보를 Range 객체에 저장
      var sel = window.getSelection();
      sel.removeAllRanges(); //기존 선택정보 삭제
      sel.addRange(range); //텍스트 정보 선택
      document.execCommand("copy"); //복사
      sel.removeRange(range); //선택 정보 삭제
      try{
        window.Android.inviteCode();
      }catch (error){
        console.log(error);
      }
    },
    inviteLink(target){
      var varUA = navigator.userAgent.toLowerCase();
      if ( varUA.indexOf('android') > -1) {
          //ANDDROID
          try{
            window.Android.inviteLink(target);
          }catch (error){
            console.log(error);
          }
      } else if ( varUA.indexOf("iphone") > -1||varUA.indexOf("ipad") > -1||varUA.indexOf("ipod") > -1 ) {
          //IOS
          try{
            window.webkit.messageHandlers.inviteLink.postMessage(target);
          }catch (error){
            console.log(error);
          }
      } else {
          //아이폰, 안드로이드 외 
      }
    },
    inviteCode(){
      var varUA = navigator.userAgent.toLowerCase();
      if ( varUA.indexOf('android') > -1) {
          //ANDDROID
          try{
            window.Android.inviteCode();
          }catch (error){
            console.log(error);
          }
      } else if ( varUA.indexOf("iphone") > -1||varUA.indexOf("ipad") > -1||varUA.indexOf("ipod") > -1 ) {
          //IOS
          try{
            window.webkit.messageHandlers.inviteCode.postMessage(" ");
          }catch (error){
            console.log(error);
          }
      } else {
          //아이폰, 안드로이드 외 
      }
    }
  }
}
</script>

<style>

</style>